import { useForceUpdate } from '../../hooks/use-force-update'

export type UpdatablePropsType<T> = {
    setUpdatableResult: (updatableResult: {
        element: React.ReactElement
        forceUpdate: () => void
    }) => void
    component: React.FC<T>
    props: T
}

export function Updatable<T extends JSX.IntrinsicAttributes>(
    props: React.PropsWithChildren<UpdatablePropsType<T>>
) {
    const forceUpdate = useForceUpdate()
    const Component = props.component

    const elem = <Component {...props.props} />
    props.setUpdatableResult({ element: elem, forceUpdate })
    return elem
}
